module.exports = __webpack_public_path__ + "static/images/vip-task-enter.png?v=23d09b7";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/images/vip-task-enter.png
// module id = BqRr
// module chunks = 1